import React, { useEffect, useRef } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Modal } from '@doxyme/ui';
import { getAngularService } from '../../../../../core/helpers/get-angular-service';
import './preview-modal.scss';
export const PreviewModal = ({ isOpen, onClose, institution, }) => {
    const intl = useIntl();
    const formatMessage = intl.formatMessage.bind(intl);
    const previewContainerRef = useRef(null);
    const scopeRef = useRef(null);
    useEffect(() => {
        if (!isOpen || !previewContainerRef.current) {
            return;
        }
        const loadPreview = async () => {
            try {
                const institutionHomeModule = await import('../../../../../../_components/institution-home/institution-home');
                const $injector = getAngularService('$injector');
                $injector.loadNewModules([institutionHomeModule.default]);
                const $compile = $injector.get('$compile');
                const $rootScope = $injector.get('$rootScope');
                const scope = $rootScope.$new();
                scopeRef.current = scope;
                scope.vm = {
                    institution: institution,
                    rooms: [],
                    previewClass: 'institution-home-preview',
                    previewer: {
                        hide: onClose,
                    },
                };
                const template = `
          <institution-home
            ng-class="vm.previewClass"
            current-institution="vm.institution"
            rooms="vm.rooms"
            previewer="vm.previewer"
          ></institution-home>
        `;
                const element = $compile(template)(scope);
                if (previewContainerRef.current) {
                    previewContainerRef.current.innerHTML = '';
                    previewContainerRef.current.append(element[0]);
                }
                scope.$digest();
            }
            catch {
                // Preview failed to load
            }
        };
        void loadPreview();
        // eslint-disable-next-line consistent-return
        return () => {
            if (scopeRef.current !== null && scopeRef.current !== undefined) {
                scopeRef.current.$destroy();
                scopeRef.current = null;
            }
        };
    }, [isOpen, institution, onClose]);
    return (<Modal isOpen={isOpen} onClose={onClose} title={formatMessage({
            id: 'account.settings.enterprise.theme.preview-btn',
        })} size="large">
      <div className="preview-modal-content">
        <div className="institution-home-preview">
          <div ref={previewContainerRef}></div>
        </div>
        <div className="preview-modal-actions">
          <button type="button" className="btn btn-primary" onClick={onClose}>
            <FormattedMessage id="account.settings.enterprise.theme-edit.preview.exit"/>
          </button>
        </div>
      </div>
    </Modal>);
};
